/* Paw & Meadow card purchasing. Server-rendered forms keep Shopify's own data authoritative. */
(() => {
  'use strict';
  const theme = window.PawTheme;
  const dialog = document.getElementById('CardPurchase');
  const mount = dialog?.querySelector('[data-card-purchase-mount]');
  if (!theme || !mount) return;
  const root = (theme.config.root || '/').replace(/\/?$/, '/');
  let revision = 0;
  let pending;
  let bulkBusy = false;
  dialog.addEventListener('close', () => { window.PawCardOptions?.disposeWithin(mount);revision++; pending?.abort(); mount.removeAttribute('aria-busy'); });
  document.addEventListener('paw:cart', () => { if (dialog.open) dialog.close(); });
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-card-purchase]');
    if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    const handle = trigger.dataset.cardPurchase;
    if (!/^[a-z0-9][a-z0-9-]*$/.test(handle || '')) return;
    event.preventDefault();
    const current = ++revision;
    pending?.abort();
    pending = new AbortController();
    dialog.classList.toggle('pc-dialog--drawer', trigger.dataset.purchasePlacement === 'drawer');
    dialog.querySelector('h2').textContent = dialog.dataset.loadingText;
    window.PawCardOptions?.disposeWithin(mount);
    mount.textContent = dialog.dataset.loadingText;
    mount.setAttribute('aria-busy', 'true');
    theme.openDialog(dialog, trigger);
    try {
      const response = await fetch(root + 'products/' + handle + '?section_id=card-purchase', { credentials: 'same-origin', signal: pending.signal });
      if (!response.ok) throw new Error(theme.config.strings.load_error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-card-purchase-content]');
      if (!content) throw new Error(theme.config.strings.load_error);
      if (current !== revision || !dialog.open) return;
      // Section responses can contain editor scripts; forms need no execution.
      content.querySelectorAll('script').forEach(script => script.remove());
      mount.replaceChildren(content);window.PawCardOptions?.initialise(content);
      const heading = dialog.querySelector('h2');
      heading.textContent = content.querySelector('h3')?.textContent || theme.config.strings.add;
    } catch (error) {
      if (current !== revision || error.name === 'AbortError') return;
      const message = document.createElement('p'); message.textContent = error.message;
      const link = document.createElement('a'); link.href = trigger.href; link.textContent = trigger.textContent.trim(); link.className = 'text-link';
      mount.replaceChildren(message, link);
    } finally { if (current === revision) mount.removeAttribute('aria-busy'); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-card-bulk]');
    if (!form) return;
    event.preventDefault();
    if (bulkBusy) return;
    const error = form.querySelector('[data-form-error]');
    const items = [];
    error.textContent = '';
    for (const input of form.querySelectorAll('[data-card-quantity]')) {
      const quantity = Number(input.value), min = Number(input.dataset.min), step = Number(input.dataset.step), max = input.max === '' ? Infinity : Number(input.max);
      if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > max || (quantity > 0 && (quantity < min || (quantity - min) % step !== 0))) {
        error.textContent = form.dataset.quantityError;
        input.focus(); return;
      }
      if (quantity > 0) items.push({ id: Number(input.dataset.variantId), quantity });
    }
    if (!items.length) { error.textContent = theme.config.strings.choose_quantity; return; }
    const submit = event.submitter || form.querySelector('[type="submit"]');
    bulkBusy = true; submit.disabled = true; submit.setAttribute('aria-busy', 'true');
    try { await theme.addItems(items, submit); }
    catch (failure) { error.textContent = failure.message; }
    finally { bulkBusy = false; submit.disabled = false; submit.removeAttribute('aria-busy'); }
  });
})();
